import { FooterContainer, FooterLogoImage, FooterText, LogoItem } from './Footer.style';
import { LogoNttDataColorImage, LogoValeColorImage } from '@images';

export function Footer() {
  return (
    <FooterContainer>
      <LogoItem>
        <FooterText>Uma iniciativa</FooterText>
        <FooterLogoImage
          src={LogoValeColorImage}
          alt="Logo Vale"
          height={20}
          style={{ marginTop: 4 }}
        />
      </LogoItem>
      <LogoItem>
        <FooterText>em parceria com</FooterText>
        <FooterLogoImage
          src={LogoNttDataColorImage}
          alt="Logo NTT DATA"
          height={15}
          style={{ marginTop: 8 }}
        />
      </LogoItem>
    </FooterContainer>
  );
}
